import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { DefaultScenarioAmexGreat } from '@components/AddressUploadAmexGreat/DefaultScenario'
import { ResidenceProofRetryScenarioAmexGreat } from '@components/AddressUploadAmexGreat/ResidenceProofRetryScenario'
import { IdCardRetryScenarioAmexGreat } from '@components/AddressUploadAmexGreat/IdCardRetryScenario'
import spinner from '@assets/amex-great/spinner.svg'
import { AmexGreatLayout } from './AmexGreatLayout'

// AddressUploadIkanoPage in the Amex card application layout
export const AddressUploadAmexGreatPage = observer(() => {
  const store = useContext(StoreContext)

  const { context } = store.ScenarioState
  const { pixelSpeak: trans } = store.TranslationsState.translations

  const [loading, setLoading] = useState(false)

  const renderUploadComponent = () => {
    if (context?.isRetryAttempt && context?.previousAttempt?.documentType === 'ResidenceProof') {
      return <ResidenceProofRetryScenarioAmexGreat setLoading={setLoading} />
    } else if (context?.isRetryAttempt && context?.previousAttempt?.documentType === 'IdCard') {
      return <IdCardRetryScenarioAmexGreat setLoading={setLoading} />
    }

    return <DefaultScenarioAmexGreat setLoading={setLoading} />
  }

  return (
    <AmexGreatLayout centered={loading}>
      {loading ? (
        <div className="amex-great__verifying" role="status">
          <h2 className="amex-great__heading">{trans.verifying}</h2>
          <img className="amex-great__spinner" src={spinner} alt="" width={48} height={48} />
        </div>
      ) : (
        <>{renderUploadComponent()}</>
      )}
    </AmexGreatLayout>
  )
})
